import { Skeleton, SkeletonText } from '@/components/UI/Skeleton'
import styles from './SpotDetail.module.css'

/**
 * SpotDetail の形状に合わせたスケルトンプレースホルダー。
 * スポット詳細のローディング中に表示する。
 *
 * NOTE: ヒーロー画像エリアの height={250} は SpotDetail.module.css の
 * `.imageArea { height: 250px }` に合わせている。CSS 変更時は追従すること。
 */
export const SpotDetailSkeleton = () => {
  return (
    <div>
      {/* ── ヒーロー画像エリア ── */}
      <div className={styles.imageArea}>
        <Skeleton variant="rect" height={250} />
      </div>

      {/* ── 情報エリア ── */}
      <div className={styles.info}>
        {/* スポット名 */}
        <Skeleton variant="text" width="70%" height={24} className="mb-2" />
        {/* 住所行 */}
        <Skeleton variant="text" width="55%" height={14} className="mb-1" />
        {/* URL行 */}
        <Skeleton variant="text" width="40%" height={14} className="mb-2" />
        {/* タグバッジ群 */}
        <div className="flex gap-2 mt-2">
          <Skeleton variant="rect" width={60} height={20} />
          <Skeleton variant="rect" width={72} height={20} />
          <Skeleton variant="rect" width={52} height={20} />
        </div>
      </div>

      {/* ── アクションエリア ── */}
      <div className={styles.actionArea}>
        {/* SNS アイコン群 */}
        <div className="flex gap-2">
          <Skeleton variant="circle" width={32} />
          <Skeleton variant="circle" width={32} />
        </div>
        {/* AR・音声ガイドボタン */}
        <div className="flex gap-3">
          <Skeleton variant="circle" width={48} />
          <Skeleton variant="circle" width={48} />
        </div>
      </div>

      {/* ── スタンプ獲得ボタン ── */}
      <div className={styles.stampButton}>
        <Skeleton variant="rect" height={36} />
      </div>

      {/* ── タブ（詳細タブのみ表示） ── */}
      <div className="flex border-b border-gray-200 mt-2">
        <Skeleton variant="text" width={60} height={36} className="mx-4" />
      </div>

      {/* ── 詳細テキスト ── */}
      <div className="p-4">
        <SkeletonText lines={5} lastLineWidth="50%" />
      </div>
    </div>
  )
}
